import styled from 'styled-components';

export const AvatarContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 2rem;
`;
